core.filter('stateOfHealthSimulationIcfEntrySimulationResult', ['$translate', function ($translate) {
    return function (input) {
        if(input) {
            return $translate.instant('T.MODULE.VISIT.STATE_OF_HEALTH_SIMULATION_ICF_ENTRY_SIMULATION_RESULT.' + input);
        } else {
            return ''
        }
    };
}]);